"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.EditedFeature=void 0;var d;(function(e){e.Address="address",e.Products="products"})(d||(exports.EditedFeature=d={}));
//# sourceMappingURL=EditedFeature.js.map
